module.exports = __webpack_public_path__ + "images/stickers/pete-award@2x.43dd35d5e48a876a50fc.png";